"use client";

import { routineResponseSchema } from "../../../lib/types/schema/routineResponseSchema";
import type { UseRequestQueryProps } from "../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../request/hooks/useRequestQuery";
import { keyRoutine } from "./keyRoutine";

export type UseRequestRoutineProps = UseRequestQueryProps;

export const useRequestRoutine = ({
  ...props
}: UseRequestRoutineProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: routineResponseSchema,
      urlBackendPath: "/routine/v2",
    },
    queryKey: keyRoutine(),
  }),
});
